import React from 'react';
import cn from 'classnames';
import style from './contact.mod.scss';
import Container from '../layout/container/container';
import Spacing from '../layout/spacing/spacing';
import { GatsbyImage } from 'gatsby-plugin-image';
import Phone from '../global/icons/phone';
import Email from '../global/icons/email';
import Linkedin from '../global/icons/linkedin';
import Form from '../form/form';
import { motion } from 'framer-motion';

const Contact = ({
  heading,
  personImage,
  personName,
  personTitle,
  personPhone,
  personEmail,
  linkedinUrl,
  formTitle,
}) => {
  const classes = cn(style.contact, {
    //[style[`contact--${side}`]]: side,
  });

  const contentVariants = {
    offscreen: {
      opacity: 0,
    },
    onscreen: {
      opacity: 1,
      transition: {
        duration: 1,
        delay: 0.2,
      },
    },
  };

  return (
    <Container size="xl">
      <motion.div
        variants={contentVariants}
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true, amount: 0.1 }}
      >
        <div className={classes}>
          <div className={style.contact__person_wrapper}>
            <div className={style.contact__person_image}>
              <GatsbyImage
                image={personImage.gatsbyImageData}
                alt={personImage.alt}
              />
              <div className={style.contact__person_gradient}></div>
              <div className={style.contact__person_details}>
                <div className={style.contact__person_name}>{personName}</div>
                <div className={style.contact__person_title}>{personTitle}</div>
              </div>
            </div>
            <div className={style.contact__person_socials}>
              <div>
                <a target="_blank" href={`tel:${personPhone}`} name="Make Phone Call">
                  <Phone />
                </a>
              </div>
              <div>
                <a target="_blank" href={`mailto:${personEmail}`} name="Email Gareth">
                  <Email />
                </a>
              </div>
              <div>
                <a target="_blank" href={linkedinUrl} name="View Gareth's LinkedIn">
                  <Linkedin />
                </a>
              </div>
            </div>
          </div>

          <div className={style.contact__form}>
            <Form heading={formTitle} />
          </div>
        </div>
      </motion.div>
    </Container>
  );
};

export default Contact;
